module.exports = __webpack_public_path__ + "img/charts-graph-bg.714471b0.png";